export let token = sessionStorage.getItem('token');
export let environment = sessionStorage.getItem("env") ? JSON.parse(sessionStorage.getItem("env")) : {};
/** DEBUG **/
environment.debug = environment.hasOwnProperty("debug") ? environment.debug : location.href.indexOf('localhost') !== -1;

/** RELOAD APP IF NOT LOADED SESSION **/
//if(!environment || !environment.activeConfig) location.reload();
